<template>
  <a-form
    layout="vertical"
    :model="form"
    ref="formRef"
    name="add_config_field"
    @finish="handleSubmit"
  >
    <a-form-item
      label="Key"
      name="key"
      :rules="[{ required: true, message: 'Key is required' }]"
    >
      <a-input
        placeholder="e.g. proxy_timeout"
        v-model:value="form.key"
      ></a-input>
    </a-form-item>

    <a-form-item
      label="Value Type"
      name="value_type"
      :rules="[{ required: true, message: 'Value type is required' }]"
    >
      <a-select
        v-model:value="form.value_type"
        placeholder="Select type"
        :options="typeOptions"
        @change="form.default_value = null"
      ></a-select>
    </a-form-item>

    <a-form-item
      label="Default Value"
      name="default_value"
      :rules="[{ required: true, message: 'Default value is required' }]"
    >
      <a-select
        v-if="form.value_type === 'bool'"
        v-model:value="form.default_value"
        :options="boolOptions"
        placeholder="Select value"
      ></a-select>
      <a-input-number
        v-else-if="form.value_type === 'int' || form.value_type === 'float'"
        v-model:value="form.default_value"
        style="width: 100%"
        placeholder="Enter number"
        :precision="form.value_type === 'int' ? 0 : undefined"
      ></a-input-number>
      <a-textarea
        v-else-if="form.value_type === 'json'"
        v-model:value="form.default_value"
        placeholder='e.g. {"key": "value"}'
        :rows="3"
      ></a-textarea>
      <a-input
        v-else
        v-model:value="form.default_value"
        placeholder="Enter default value"
      ></a-input>
    </a-form-item>

    <a-form-item label="Description" name="description">
      <a-input
        v-model:value="form.description"
        placeholder="Brief description of this config field"
      ></a-input>
    </a-form-item>

    <div class="d-flex justify-content-end">
      <a-button type="primary" html-type="submit" :disabled="!isFormValid">
        Create
      </a-button>
    </div>
  </a-form>
</template>

<script>
import UserConfigService from '../../../../services/userConfig';

export default {
  name: 'AddConfigField',
  inject: ['toast'],
  emits: ['created'],
  data() {
    return {
      form: {
        key: '',
        value_type: null,
        default_value: null,
        description: '',
      },
      typeOptions: [
        { value: 'bool', label: 'Boolean' },
        { value: 'int', label: 'Integer' },
        { value: 'float', label: 'Float' },
        { value: 'string', label: 'String' },
        { value: 'json', label: 'JSON' },
      ],
      boolOptions: [
        { value: true, label: 'true' },
        { value: false, label: 'false' },
      ],
    };
  },
  computed: {
    isFormValid() {
      return (
        this.form.key &&
        this.form.value_type &&
        this.form.default_value !== null &&
        this.form.default_value !== ''
      );
    },
  },
  methods: {
    async handleSubmit() {
      const payload = { ...this.form };

      if (payload.value_type === 'json' && typeof payload.default_value === 'string') {
        try {
          payload.default_value = JSON.parse(payload.default_value);
        } catch {
          this.toast.error('Invalid JSON for default value');
          return;
        }
      }

      const [error] = await UserConfigService.createConfigField(payload);
      if (error) {
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          'Failed to create config field';
        this.toast.error(msg);
        return;
      }
      this.toast.success('Config field created');
      this.$emit('created');
    },
  },
};
</script>
